module.exports = __webpack_public_path__ + "img/Logosnetto-logo_tile.9aa18f7.png";